var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props),
    React.createElement("path", { fill: "#FFF", fillRule: "evenodd", d: "M9.21 4c.884 0 1.6.716 1.6 1.6v4.8c0 .884-.716 1.6-1.6 1.6H3.1c-.884 0-1.6-.716-1.6-1.6V5.6c0-.884.716-1.6 1.6-1.6h6.11zm4.49 1.367c.442 0 .8.358.8.8v3.66c0 .138-.035.273-.103.392-.216.386-.704.522-1.09.306l-1.243-.7c-.252-.141-.408-.408-.408-.697V6.866c0-.289.156-.555.408-.697l1.244-.7c.12-.067.255-.102.392-.102z" })
  );
});